<template>
  <div class="px-3 pb-3">
    <!-- <div class="panel-bg-file my-3"> -->
    <div :class="['panel-bg-file my-3', { error: v.file.$error }]">
      <div v-if="!isUploaded" class="pointer text-center">
        <input
          type="file"
          name="uploadFile"
          id="uploadFile"
          style="display:none"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          @change="handleFileChange"
        />
        <b-button class="btn-upload-finance">
          <label for="uploadFile" class="mb-0 pointer">
            <font-awesome-icon
              icon="file-upload"
              color="white"
              class="bg-icon mr-2"
            />เลือกไฟล์</label
          ></b-button
        >
        <p class="mb-0 note-upload-file">อัพโหลดไฟล์ประเภท xlsx</p>
      </div>

      <div v-if="isUploaded" class="w-100 p-3">
        <b-row class="">
          <b-col
            cols="3"
            class="d-flex justify-content-center align-items-center"
          >
            <div
              class="img-file"
              v-bind:style="{
                backgroundImage: 'url(' + imgExcel + ')',
              }"
            ></div>
          </b-col>
          <b-col
            cols="4"
            class="d-flex justify-content-end align-items-center"
            >{{ this.form.excelFile.name }}</b-col
          >
          <b-col
            cols="3"
            class="d-flex justify-content-center align-items-center"
            >{{ this.form.excelFile.size }} KB</b-col
          >
          <b-col cols="2" class="d-flex justify-content-end align-items-center"
            ><b-button class="btn-cancel-file" @click="cancelFile()">
              <font-awesome-icon icon="times" color="white" /> </b-button
          ></b-col>
        </b-row>
      </div>
    </div>
    <div class="pl-1">
      <p class="text-error mb-0" v-if="v.file.$error">กรุณาเลือกไฟล์</p>
      <b-row>
        <b-col sm="6">
          <InputText
            textFloat="อีเมล"
            v-model="form.email"
            isRequired
            placeholder="กรุณากรอกอีเมล"
            type="text"
            :isValidate="v.email.$error"
            :v="v.email"
          />
        </b-col>
      </b-row>

      <p class="text-note mb-2">หมายเหตุ</p>
      <p class="mb-0" v-html="note">
        {{ note }}
      </p>
    </div>
  </div>
</template>

<script>
import { BIcon } from "bootstrap-vue";
import InputText from "@/components/inputs/InputText";
export default {
  name: "FinanceImportPanel",
  components: { BIcon, InputText },
  props: {
    form: {
      type: Object,
      isRequired: true,
    },
    v: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      note:
        "หลังจากอัพโหลดไฟล์เสร็จสิ้น สามารถกดบันทึกได้ทันที<br />ระบบจะประมวลผลแล้วส่งเข้าอีเมลของคุณ<br /> - ในกรณีอัพโหลดไฟล์สำเร็จ: สามารถกดเข้ามาตรวจสอบข้อมูลได้<br />- ในกรณีอัพโหลดไฟล์ไม่สำเร็จ (บางรายการมีปัญหา): ระบบจะแจ้งเตือนเพื่อให้คุณมาทำรายการใหม่",
      isUploaded: false,
      imgExcel:
        "https://img.utdstc.com/icon/285/439/2854390d6f2d7b3005cfd0f8996c9e80b3480794a05f2f6253cdd0c8a60c1761:200",
    };
  },
  computed: {
    showUploadFile: {
      get: function() {
        console.log("commm: " + this.form.excelFile);
        if (this.form.excelFile) {
          return true;
        } else {
          return false;
        }
      },
      set: function() {},
    },
  },
  methods: {
    handleFileChange(e) {
      console.log("e", e);
      if (e.target.files.length) {
        this.form.excelFile = e.target.files[0];
        console.log(this.form.excelFile);
        if (this.form.excelFile.size > 10000000) {
          console.log("ไฟล์นี้มีขนาดใหญ่เกินไป");
        }
        this.getBase64(this.form.excelFile);
        this.isUploaded = true;
      }
    },
    getBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function() {
        this.form.file = reader.result;
      }.bind(this);
      reader.onerror = function(error) {
        this.form.file = "";
        console.log("Error: ", error);
      }.bind(this);
    },
    cancelFile() {
      this.form.excelFile = "";
      this.form.file = "";
      this.isUploaded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-note {
  text-decoration: underline;
  color: #6c64be;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.panel-bg-file {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border: 2px dashed #979797;
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.panel-bg-file.error {
  border-color: red !important;
}
.note-upload-file {
  font-size: 14px;
  padding-top: 5px;
  color: #8a93a2;
}
.btn-cancel-file {
  background-color: #8a44c3;
  height: 35px;
  width: 35px;
}
.img-file {
  width: 40%;
  padding-bottom: 100.5%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.btn-upload-finance {
  background-color: #6c64be !important;
  color: #ffffff !important;
  min-width: 120px;
  width: 100%;
  font-weight: bold;
  transition: 0.3s;
  border-radius: 6px;
  border-color: #6c64be;
  height: 42px;
  padding: 10px 20px;
}
</style>
